import { subscribeToReports } from "../clients/subscribeClient";

export const subscribe = async (user_id, subscriptionType, mobile = null) => {
  return await subscribeToReports(user_id, subscriptionType, mobile);
};
